module.exports = __webpack_public_path__ + "img/subway_dnepr.99a226b.png";